import { createFileRoute } from "@tanstack/react-router";
import { AgendaShell } from "@/components/agenda/agenda-shell";
import { AgendaParametro } from "@/components/agenda/agenda-parametro";

export const Route = createFileRoute("/agenda/parametro")({
  component: () => (
    <AgendaShell>
      <AgendaParametro />
    </AgendaShell>
  ),
  head: () => ({ meta: [{ title: "Parâmetro — Agenda — GPS Drive" }] }),
});
